module.exports = __webpack_public_path__ + "static/img/vis.fab67bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/vis.jpg
// module id = AD3L
// module chunks = 0